var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0M6 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0M4.54 16.5h10.923A4.07 4.07 0 0 0 11.43 13H8.575a4.07 4.07 0 0 0-4.031 3.5zM3 17.072A5.57 5.57 0 0 1 8.572 11.5h2.856A5.57 5.57 0 0 1 17 17.072a.93.93 0 0 1-.928.928H3.928A.93.93 0 0 1 3 17.072"
  })));
};
export default SvgUser;